const SET_DANH_SACH_QUAN_LY_LOAI = (state, danhSachQuanLyLoai) => {
  state.danhSachQuanLyLoai = danhSachQuanLyLoai;
};

const SET_DANH_SACH_QUAN_LY_NGUON = (state, danhSachQuanLyNguon) => {
  state.danhSachQuanLyNguon = danhSachQuanLyNguon;
};

const SET_DANH_SACH_QUAN_LY_THONG_BAO = (state, danhSachQuanLyThongBao) => {
  state.danhSachQuanLyThongBao = danhSachQuanLyThongBao;
};

const SET_DANH_SACH_LICH_SU_THAO_TAC = (state, lichSuThaoTac) => {
  state.lichSuThaoTac = lichSuThaoTac;
};

export default {
  SET_DANH_SACH_QUAN_LY_LOAI,
  SET_DANH_SACH_QUAN_LY_NGUON,
  SET_DANH_SACH_QUAN_LY_THONG_BAO,
  SET_DANH_SACH_LICH_SU_THAO_TAC
};
